import { PhoneArrowUpRightIcon, EnvelopeIcon } from "@heroicons/react/24/solid";
import { RiWhatsappFill } from "react-icons/ri";
import { CAMPAIGN_TYPE } from "V2.0/HomePages/HomeCampaign/SingleCampaignAdd";

// NOTE: Frontend also has an Email tab entry here (MdOutlineAttachEmail icon), but this port
// deliberately drops it per task-4-brief.md Step 3 — the create flow (Task 8) has no way to
// create an Email bulk campaign, so an Email tab would be a dead end for users. Catalyst's
// CAMPAIGN_TYPE also has no EMAIL value to key it off of.
// NOTE: Frontend's entries key off `key`; this port uses `type` per task-4-brief.md Step 3
// (`{type, icon, label, iconClassName}`).
const TAB_CONFIG = [
  { type: CAMPAIGN_TYPE.CALL, label: "Call", icon: PhoneArrowUpRightIcon, iconClassName: "text-amber-500" },
  { type: CAMPAIGN_TYPE.WHATSAPP, label: "WhatsApp", icon: RiWhatsappFill, iconClassName: "text-green-500" },
  { type: CAMPAIGN_TYPE.SMS, label: "SMS", icon: EnvelopeIcon, iconClassName: "" },
];

export default function BulkCampaignTabs({ activeTab, onTabChange }) {
  return (
    <div className="flex items-end gap-x-0.5 -mb-px">
      {TAB_CONFIG.map((tab) => {
        const isActive = tab.type === activeTab;
        const Icon = tab.icon;
        return (
          <button
            key={tab.type}
            type="button"
            onClick={() => onTabChange(tab.type)}
            className={[
              "flex items-center gap-x-1.5 px-5 py-2.5 text-sm font-medium rounded-t-lg border border-b-0 transition-colors",
              isActive
                ? "bg-white text-gray-900 border-zinc-200 z-10 relative"
                : "bg-gray-50 text-gray-500 border-transparent hover:bg-gray-100 hover:text-gray-700",
            ].join(" ")}
          >
            <Icon className={`size-4 shrink-0 ${tab.iconClassName}`} />
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
